import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import DashboardMessagesWrapper from './DashboardMessagesWrapper';
import DashboardMessages from './DashboardMessages';

loadDOMComponent({
	selector: 'react-dashboard-messages',
	// @ts-ignore
	callback: ({ container, context, props }) => {
		const patientId = container.getAttribute('patientId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<DashboardMessagesWrapper>
						<DashboardMessages patientId={patientId} />
					</DashboardMessagesWrapper>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
